import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import AdFoxFactory from '../AdFox/AdFoxFactory';
import config from '../../config';

class QuadroSlider extends Component {
  constructor (props) {
    super(props);

    this.state = {
      currentIndex: 0
    };

    this.items = props.items;
    this.perPage = 4;
    this.perRow = 2;
    this.itemsCount = this.items.size;
    this.lastIndex = this.itemsCount - this.perPage;

    this.prevPage = this.prevPage.bind(this);
    this.nextPage = this.nextPage.bind(this);

    this.timeoutRotate = null;
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if (!nextProps.items.equals(this.props.items)) {
      this.items = nextProps.items;
      this.itemsCount = this.items.size;
      this.lastIndex = this.itemsCount - this.perPage;
    }
  }

  componentDidMount () {
    if (this.props.autoRotate) {
      this.timeoutRotate = setInterval(this.nextPage, 5000);
    }
  }

  componentWillUnmount () {
    this.timeoutRotate && clearInterval(this.timeoutRotate);
  }

  nextPage (e) {
    e && e.preventDefault();
    const index = this.state.currentIndex;
    const nextIndex = index < this.lastIndex ? index + this.perPage : 0;

    this.setState({ currentIndex: nextIndex });
  }

  prevPage (e) {
    e.preventDefault();
    const index = this.state.currentIndex;
    const prevIndex = index > 0 ? index - this.perPage : this.lastIndex;

    this.setState({ currentIndex: prevIndex });
  }

  isShowArrow () {
    return this.props.items.size > this.perPage;
  }

  getItems () {
    const items = this.props.items.slice(this.state.currentIndex, this.state.currentIndex + this.perPage);
    const CardItem = this.props.cardItemClass;

    const items1 = items.slice(0, this.perRow);
    const items2 = items.slice(this.perRow);

    return [
        (<div key={1} className='row'>{ items1.toArray().map(item => <CardItem key={item.getId()} data={item} />) }</div>),
        (<div key={2} className='row'>{ items2.toArray().map(item => <CardItem key={item.getId()} data={item} />) }</div>)
    ];
  }

  render () {
    const {wrapperClassName, loading, dealType, realtyType, adfoxPosition, btnLabel, btnLink} = this.props;
    const itemList = this.getItems();
    const adFoxEl = AdFoxFactory(this.props.regionName).getBySection(adfoxPosition, dealType, realtyType);

    if (!loading && !itemList.length) {
      return null;
    }

    return (
      <div className={'quadro-slider ' + (wrapperClassName || '')}>
        <h3 className='quadro-slider__title'>{ this.props.title }</h3>

        <div className='quadro-slider__content'>
          {this.isShowArrow() && <button className='arrow icon-arrow-left-new' onClick={this.prevPage} key='left' />}
          {this.isShowArrow() && <button className='arrow icon-arrow-right-new' onClick={this.nextPage} key='right' />}

          <div className='quadro-slider__page_wrp'>
            <div className={'quadro-slider__page' + (loading ? ' loading' : '')}>
              {
                loading
                ? (
                  <div className='ajax-waiting-overlay'>
                    <div className='radial-progress'>
                      <div className='circle'>
                        <div className='fill' />
                      </div>
                    </div>
                  </div>
                )
                : itemList
              }
            </div>
          </div>
          <div className={'quadro-slider__promo ' + (wrapperClassName || '')}>
            {config.enableAdFox && adFoxEl ? adFoxEl : null}
          </div>
        </div>

        {
          btnLink && btnLabel && (
            <div className='footer'>
              <a className='btn-base btn-hollow' href={btnLink}>{btnLabel}</a>
            </div>
          )
        }
      </div>
    );
  }
}

QuadroSlider.propTypes = {
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  items: PropTypes.object,
  adfoxPosition: PropTypes.string,
  regionName: PropTypes.string.isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,
  cardItemClass: PropTypes.func.isRequired,
  wrapperClassName: PropTypes.string,
  autoRotate: PropTypes.bool,
  btnLabel: PropTypes.string,
  btnLink: PropTypes.string
};

QuadroSlider.defaultProps = {
  wrapperClassName: null,
  loading: false,
  items: new List(),
  adfoxPosition: null,
  autoRotate: false,

  btnLabel: null,
  btnLink: null
};

export default QuadroSlider;



// WEBPACK FOOTER //
// ./src/ui/Sliders/QuadroSlider.jsx